import { useEffect, useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { EbookDownloadDto, EbookDownloadResponseDto } from 'tdc-web-backend/ebook/schemas';
import CustomInput from '../../../../components/custom-input/CustomInput';
import CustomButton from '../../../../components/button/CustomButton';
import useCreate from '../../../../utils/hooks/crud-hooks/useCreate';
import useNotification from '../../../../utils/hooks/useNotification';
import { secondaryGreen } from '../../../../utils/color';

const DownloadForm = () => {
  const [downloadWindow, setDownloadWindow] = useState<Window | null>(null);
  const [dataSubmitted, setDataSubmitted] = useState(false);
  const { notify } = useNotification();

  const form = useForm({
    defaultValues: {
      name: '',
      email: '',
      ebook: 'innovative-agency-growth-strategies',
      agreeTos: false,
    },
  });

  const { mutate: submitData, isLoading } = useCreate<EbookDownloadResponseDto, EbookDownloadDto>({
    resource: 'ebook/download',
  });
  useEffect(() => {
    const checkWindow = setInterval(() => {
      if (downloadWindow && downloadWindow.closed) {
        setDownloadWindow(null);
        setDataSubmitted(true);
      }
    }, 1000);

    return () => clearInterval(checkWindow);
  }, [downloadWindow]);

  const onSubmit = async (data: any) => {
    submitData(data, {
      onSuccess: (response) => {
        const { link } = response.data;
        const newWindow = window.open(link, '_blank');
        setDownloadWindow(newWindow);
      },
      onError: (error) => {
        console.log('Error submit callback');
        notify.error('Something went wrong. Please try again later.');
      },
    });
  };

  return (
    <FormProvider {...form}>
      {dataSubmitted ? (
        <Box
          sx={{
            px: { xs: 2, md: 3 },
            py: 2,
            borderRadius: '4px',
            scrollMarginTop: '120px',
            width: '100%',
            backgroundColor: secondaryGreen[100],
            textAlign: 'center',
          }}
        >
          <Typography variant="publicBody3Regular" sx={{ color: secondaryGreen[801] }}>
            Thank you! The eBook should now be downloaded to your device.
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            //   ...LAYOUT_DEFAULTS,
            px: { xs: 2, md: 6 },
            py: 6,
            borderRadius: '8px',
            //   border: '1px solid #E6E8F0',
            boxShadow: ' 1px 10px 30px 0px rgba(56, 69, 114, 0.10)',
            scrollMarginTop: '120px',
            width: '100%',
            //   maxWidth: '600px',
          }}
        >
          <Stack justifyContent="center" alignContent="center" alignItems="center">
            <Stack sx={{ width: '100%', maxWidth: '560px' }} spacing={4}>
              <CustomInput
                input={<CustomInput.Text />}
                name="name"
                type="text"
                label="* Name"
                placeholder="Enter your first and last name"
                required
                disabled={isLoading || !!downloadWindow}
              />
              <CustomInput
                input={<CustomInput.Text />}
                name="email"
                type="email"
                label="* Email"
                placeholder="Enter your e-mail"
                required
                disabled={isLoading || !!downloadWindow}
                validationRegEx={{
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: 'Invalid email address',
                }}
              />

              <CustomInput
                input={<CustomInput.UserAgreementEbook />}
                name="agreeTos"
                required
                customRequiredMessage="This field is required"
                disabled={isLoading}
              />

              <CustomButton
                variant="primary"
                sx={{
                  height: '2.8125rem',
                  width: 'fit-content',

                  marginTop: '22px !important',
                }}
                onClick={form.handleSubmit(onSubmit)}
                loading={isLoading || !!downloadWindow}
              >
                Submit & Download
              </CustomButton>
            </Stack>
          </Stack>
        </Box>
      )}
    </FormProvider>
  );
};

export default DownloadForm;
